import React, { useState, useMemo } from 'react';
import useSystemOrganization from '../../hooks/system/query/organization/useSystemOrganization';
import { MovaticFieldGroupAsyncSelect } from '../Redesing/movatic-field-group';
import useSearchDebounce from '../../hooks/search/useSearchDebounce';
import { ISystem } from '../../ts/interface/system.interface';

interface SystemOption {
  value: string;
  name: string;
  original: ISystem;
}

function OrganizationSystemSelect({
  organization_id,
  description,
  selectedSystem,
  onChange,
}: {
  organization_id: string;
  description?: string;
  selectedSystem?: { value: string; name: string };
  onChange: (system: ISystem) => void;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');

  const debouncedSearch = useSearchDebounce(search, 500);

  const { data, isLoading, isRefetching } = useSystemOrganization(
    {},
    {
      organization_id: organization_id,
      search: debouncedSearch,
    }
  );

  const options = useMemo(
    () =>
      data?.systems?.map((system: ISystem) => ({
        value: system.gid,
        name: system.name,
        original: system,
      })) || [],
    [data?.systems]
  );

  return (
    <MovaticFieldGroupAsyncSelect
      isLoading={isLoading || isRefetching}
      label="System"
      description={description}
      name="system"
      id="system"
      open={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      options={options}
      value={selectedSystem}
      onChange={(_event: React.SyntheticEvent, newValue: SystemOption | null) => {
        if (newValue) {
          onChange(newValue.original);
        }
        setIsOpen(false);
      }}
      getOptionText={(option: any) => {
        if (typeof option === 'string') return option;
        return option.name;
      }}
      handleSearch={(e) => setSearch(e.target.value)}
      isOptionEqualToValue={(option: any, value: any) => {
        if (!option || !value) return false;
        return option.value === value.value;
      }}
    />
  );
}

export default OrganizationSystemSelect;
